import { schema } from 'normalizr'
import { getRawId } from 'util/globalId'

export const agent = new schema.Entity('agent')

export const team = new schema.Entity('team')

export const cannedReplyCategory = new schema.Entity('cannedReplyCategory')

export const attachment = new schema.Entity(
  'attachment',
  {
    creator: agent,
  },
  {
    idAttribute: entity => {
      // support gid being returned from V0 settings api
      // if exists, convert to id (scatterswap) which is used for overview page
      // otherwise return normal id
      return entity.gid ? getRawId(entity.gid) : entity.id
    },
    processStrategy: entity => {
      const updatedEntity = { ...entity }
      if (entity.gid !== undefined) {
        updatedEntity.id = getRawId(entity.gid)
        delete updatedEntity.gid
      }
      if (entity.creator_gid !== undefined) {
        updatedEntity.creator = getRawId(entity.creator_gid)
        delete updatedEntity.creator_gid
      }
      return updatedEntity
    },
  }
)

export const cannedReply = new schema.Entity(
  'cannedReply',
  {
    category: cannedReplyCategory,
    attachments: [attachment],
  },
  {
    processStrategy: entity => {
      const updatedEntity = { ...entity }
      // START: V0 Settings API response
      if (entity.gid !== undefined) {
        updatedEntity.id = getRawId(entity.gid)
        delete updatedEntity.gid
      }

      if (entity.category_gid !== undefined) {
        updatedEntity.category_id = getRawId(entity.category_gid)
        delete updatedEntity.category_gid
      }

      if (entity.creator_gid !== undefined) {
        updatedEntity.creator_id = getRawId(entity.creator_gid)
        delete updatedEntity.creator_gid
      }

      if (entity.canned_reply_categories) {
        delete updatedEntity.canned_reply_categories
      }

      if (entity.title !== undefined) {
        // it's saved as name in the entity table
        updatedEntity.name = entity.title
        delete updatedEntity.title
      }
      // END: V0 Settings API response

      // using updatedEntity here because category_id might already been changed by v0 settings entity processing above
      if (updatedEntity.category_id !== undefined) {
        if (updatedEntity.category_id !== null) {
          updatedEntity.category = { id: updatedEntity.category_id }
        } else {
          updatedEntity.category = null
        }

        delete updatedEntity.category_id
      }

      return updatedEntity
    },
    idAttribute: entity => {
      // support gid being returned from V0 settings api
      // if exists, convert to id (scatterswap) which is used for overview page
      // otherwise return normal id
      return entity.gid ? getRawId(entity.gid) : entity.id
    },
  }
)

export const cannedReplyVariables = new schema.Entity(
  'cannedReplyVariables',
  {},
  { idAttribute: 'key' }
)

export const folderCondition = new schema.Entity('folderCondition')

export const channel = new schema.Entity('channel')

export const folder = new schema.Entity(
  'folder',
  {
    agents: {
      nodes: [agent],
    },
    conditions: {
      nodes: [folderCondition],
    },
    teams: {
      nodes: [team],
    },
    channels: {
      nodes: [channel],
    },
  },
  {
    processStrategy: entity => {
      const gqlTypes = ['agents', 'conditions', 'teams', 'channels']
      gqlTypes.forEach(key => {
        if (entity[key] && entity[key].nodes) {
          // Perhaps we should merge the arrays instead of completely
          // replacing it?
          // eslint-disable-next-line no-param-reassign
          entity[key] = entity[key].nodes
        } else if (entity[key] && !Array.isArray(entity[key])) {
          // eslint-disable-next-line no-param-reassign
          entity[key] = []
        }
      })
      return entity
    },
  }
)

export const rule = new schema.Entity(
  'rule',
  {
    creator: agent,
  },
  {
    idAttribute: entity => {
      // support gid being returned from V0 settings api
      // if exists, convert to id (scatterswap) which is used for overview page
      // otherwise return normal id
      return entity.gid ? getRawId(entity.gid) : entity.id
    },
    processStrategy: entity => {
      const updatedEntity = { ...entity }
      if (entity.gid !== undefined) {
        updatedEntity.id = getRawId(entity.gid)
        delete updatedEntity.gid
      }
      if (entity.creator_gid !== undefined) {
        updatedEntity.creator = getRawId(entity.creator_gid)
        delete updatedEntity.creator_gid
      }
      return updatedEntity
    },
  }
)

export default {
  agent,
  attachment,
  rule,
  cannedReply,
  cannedReplyCategory,
  folder,
  folderCondition,
  team,
}
